import React from 'react'
import { SvgIconProps } from '../Icon.types'

export const Add: React.FC<SvgIconProps> = ({
  width = 24,
  height = 24,
  fill = 'currentColor',
  title = '',
  className,
  ...props
}) => (
  <svg
    className={className}
    aria-hidden={!title}
    focusable='false'
    width={width}
    height={height}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.9921 6V10.992H6.00006H1.00806V12V13.008H6.00006H10.9921V18V22.992H12.0001H13.0081V18V13.008H18.0001H22.9921V12V10.992H18.0001H13.0081V6V1.008H12.0001H10.9921V6Z'
      fill={fill}
    />
  </svg>
)

export default Add
